import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Container, Input, useEventCallback } from '@mui/material';

import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { pink } from '@mui/material/colors';

import { Radio, RadioGroup, FormLabel } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useRef } from 'react';
import _isEqual from 'lodash/isEqual';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
// import WorkshopFooter from "./WorkhopFooter/WorkshopFooter"

import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
//import WorkshopFooter from "./WorkhopFooter/WorkshopFooter";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../contexts/DeadlineContext";
// Inside your component


const steps = ['Step 1', 'Step 2', 'Step 3']; // Define your steps



function createData(
    id,
    coupon_code,
    workshop_id,
    disount,



) {
    return { id, coupon_code, workshop_id, disount, };
}



const rowssss = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, '789', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),



].sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));

const coupons = [
    { id: 1, code: '123', workshop_id: 6 },
    { id: 2, code: 'kfsRY7IRcI', workshop_id: 6 },
    { id: 3, code: 'micSSQ4CA', workshop_id: 28 },
    { id: 4, code: 'fixFDMJIK', workshop_id: 5 },
    { id: 5, code: '963', workshop_id: 7 },
    { id: 6, code: '258', workshop_id: 25 },
    { id: 7, code: '147', workshop_id: 26 },
];

const rows = [
    createData(1, '123', 6),
    createData(1, 'kfsRY7IRI'),
    createData(2, 'micSSQ4CA'),
    createData(3, 'fixFDMJIK', 5),
    createData(4, '963', 7),
    createData(5, '258', 25),
    createData(6, '147', 26),
].map((row, index) => {
    const coupon = coupons.find((coupon) => coupon.code === row.couponCode);
    const discount = coupon ? coupon.discount : 0;
    return { ...row, discount };
}).sort((a, b) => (a.SubmitStatus < b.SubmitStatus ? -1 : 1));


const UpdateWorkShops = (props) => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    //const bannerImage = `${process.env.PUBLIC_URL}/Abstract/loginBanerImage/abanner-bg.jpg`;
    const bannerImage = `${process.env.PUBLIC_URL}/Workshops/WorkshopImages/scfns-workshop-bg.jpg`;
    //const bannerImage = `${process.env.PUBLIC_URL}/Workshops/WorkshopImages/banner-image_workshop.jpg`;
    const gradientBackground = '#05597D';



    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const cardStyles = {
        width: isSmallScreen ? '85vw' : isMediumScreen ? '80vw' : '60vw',
        margin: 'auto',
    };


    const id = props.match.params.id;
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({
        // Initialize form data here
        firstName: '',
        lastName: '',
        email: '',
    });
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid');
    const [nameTitle, setNameTitle] = useState('');
    const [gender, setGender] = useState(''); // state to hold the selected value
    const [country, setCountry] = useState('');
    const [registrationType, setRegistrationType] = useState('');
    const [assignModule, setassignModules] = useState([]);
    const [checkmodules, setCheckedmodules] = useState([]);
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [singleWorkShopCategory, setSingleWorkShopCategory] = useState('');
    const [selectedWorkshops, setSelectedWorkshops] = useState([]);
    const [selectedWorkshopAmounts, setSelectedWorkshopAmounts] = useState([]);
    const [discountMessages, setDiscountMessages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [disabledInputs, setDisabledInputs] = useState({});
    const [showCouponInputs, setShowCouponInputs] = useState({});
    const [workshopUsedCoupeon, setWorkshopUsedCoupeon] = useState([]);
    const tableCellRef = useRef(null);
    const [isCopied, setIsCopied] = useState(false);
    const [copiedStates, setCopiedStates] = useState({});
    const [workshopTotalSeatCount, setWorkshopTotalSeatCount] = useState();
    const workshop_particpant_email = localStorage.getItem('workshop_particpant_email');
    // const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    //     color_code: "",
    //     color_code_two: "",
    //     color_code_three: "",
    //     call_emergency: "",
    //     send_email: "",
    //     event_place: "",
    //     facebook_link: "",
    //     Instagram_link: "",
    //     linkedin_link: "",
    //     twitter_link: "",
    //     abstractFooterImage: "",
    //     abstractBannerImage: "",
    //     workshopBannerImage: "",
    //     abstractSponserLogos: "",
    //     event_name: "",
    //     online_status: "",
    //     bank_status: "",
    //     cash_status: "",
    //     free_status: "",
    //     error_list: [],
    // });
    // React.useEffect(() => {
    //         axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
    //             if (res.status === 200) {
    //                 const getHomePageData = res.data.HomePageSetup;
    //                 setAbstractHomeSetup(getHomePageData);
    //             }
    //         })

    // }, [eventid]);
    const [addWorkShopParticpant, setAddWorkShopParticpant] = React.useState({
        workShop_partecpant_name: "",
        instituteWorkPlace: "",
        city: "",
        phone: "",
        particent_email: "",
        saudiCouncilno: "",
        price: "",
        profession: "",
        // password: "",
        // phone: "",
        // date: "",
        // address: "",
        // details: "",
        error_list: [],
    });
    const [editWorkShopParticpant, setEditWorkShopParticpant] = React.useState({

        category_amount: "",
        is_active: "",
        name_title: "",
        particent_address: "",
        particent_city: "",
        particent_country: "",
        particent_email: "",
        particent_gender: "",
        particent_name: "",
        particent_phone_number: "",
        particent_profession: "",
        particent_saudi_council_no: "",
        particent_workshop_categoy_id: "",
        password: "",
        error_list: [],
    });

    const [editWorkShopParticpantWorkshops, setEditWorkShopParticpantWorkshops] = React.useState({
        categoy_id: "",
        workshop_amount: "",
        workshop_code: "",
        workshop_discount: "",
        workshop_id: "",
        workshop_name: "",
        workshop_participant_id: "",
        workshop_type: "",
        workshop_coupon: "",
        workshop_url: "",
        workshop_start_time: "",
        workshop_date: "",
        payment_status: "",
    });
    const [updateWorkShopParticpantWorkshops, setupdateWorkShopParticpantWorkshops] = React.useState({

        categoy_id: "",
        workshop_amount: "",
        workshop_code: "",
        workshop_discount: "",
        workshop_id: "",
        workshop_name: "",
        workshop_participant_id: "",
        workshop_type: "",
        workshop_coupon: "",
        workshop_url: "",
        workshop_start_time: "",
        workshop_date: "",
        payment_status: "",

    });

    // const [settings, setPyamentSettings] = useState({

    //     PAYTAB_COUNTROY: '',
    //     PAYTAB_MERCHANT_EMAIL: '',
    //     PAYTAB_SECRET_KEY: '',
    //     PAYTAB_MERCHANT_ID: '',
    //     PAYTAB_STATUS: '',
    //     PAYTAB_MODE: '',

    // });
    // useEffect(() => {
    //     axios.get(`/api/get-setting/${eventid}`)
    //         .then(response => {
    //             const settingsData = response.data.settings;
    //             setPyamentSettings(settingsData);
    //         })
    //         .catch(error => {
    //             console.error('Error fetching email settings:', error);
    //         });
    // }, []);

    useEffect(() => {
        axios.get(`api/workshop-participant-edit/${id}`)
            .then(res => {
                if (res.status === 200) {
                    const participantData = res.data.data.participant;
                    const participantworkshopsData = res.data.data.workshops;
                    const participantpaymentData = res.data.data.payment;


                    setEditWorkShopParticpant(participantData);
                    setNameTitle(participantData.name_title);
                    setGender(participantData.particent_gender);
                    setCountry(participantData.particent_country);
                    setEditWorkShopParticpantWorkshops(participantworkshopsData.map(workshop => ({
                        categoy_id: workshop.categoy_id,
                        workshop_amount: workshop.workshop_amount,
                        workshop_code: workshop.workshop_code,
                        workshop_discount: workshop.workshop_discount,
                        workshop_id: workshop.workshop_id,
                        workshop_name: workshop.workshop_name,
                        workshop_participant_id: workshop.workshop_participant_id,
                        workshop_type: workshop.workshop_type,

                        payment_status: workshop.payment_status,
                        workshop_coupon: workshop.workshop.workshop_coupon,
                        workshop_url: workshop.workshop.workshop_url,
                        workshop_start_time: workshop.workshop.workshop_start_time,
                        workshop_date: workshop.workshop.workshop_date,


                    })));
                    setupdateWorkShopParticpantWorkshops(participantworkshopsData.map(workshop => ({
                        categoy_id: workshop.categoy_id,
                        workshop_amount: workshop.workshop_amount,
                        workshop_code: workshop.workshop_code,
                        workshop_discount: workshop.workshop_discount,
                        workshop_id: workshop.workshop_id,
                        workshop_name: workshop.workshop_name,
                        workshop_participant_id: workshop.workshop_participant_id,
                        workshop_type: workshop.workshop_type,

                        payment_status: workshop.payment_status,
                        workshop_coupon: workshop.workshop.workshop_coupon,
                        workshop_url: workshop.workshop.workshop_url,
                        workshop_start_time: workshop.workshop.workshop_start_time,
                        workshop_date: workshop.workshop.workshop_date,


                    })));


                    const selectedRegistrationType = participantData.particent_workshop_categoy_id;

                    axios.get(`api/workshop-category-front-single/${selectedRegistrationType}`)
                        .then((response) => {
                            if (response.status === 200) {
                                const singleWorkShopData = response.data.swsd;
                                setSingleWorkShopCategory(singleWorkShopData);
                                setWorkshopTotalSeatCount(response.data.totalSeatCount);
                                // Update the state with the selected registration type
                                // Update the state with the selected registration type
                                setEditWorkShopParticpant(prevState => ({
                                    ...prevState,
                                    particent_workshop_categoy_id: selectedRegistrationType,
                                }));



                                // setupdateWorkShopParticpantWorkshops(singleWorkShopCategory.work_shops.map(wp => ({
                                //     workshop_id: wp.id,

                                // })));

                            } else {
                                swal('Error', 'Check API Something Wrong', 'error');
                            }
                        })


                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch(error => {
                console.error('Error fetching participant data:', error);
                // Handle error as needed
            });
    }, [id]);



    useEffect(() => {
        axios.get(`api/workshop-category-front-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.workshopCategories;
                setWorkShopCategoryData(wcategoryData);


            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    useEffect(() => {
        axios.get(`api/workshop-participant-used-coupeona?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const usedCoupen = res.data.usedCoupons;
                setWorkshopUsedCoupeon(usedCoupen);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    const [colorMap, setColorMap] = useState({});
    const [eventOptionsSetup, setEventOptionsSetup] = useState({
        cate_to_abst: "",
        guest_email_action: "",
        guest_email_action: "",
        workshop_setup_status: "",
        guestBadgeImage: "",
        error_list: [],
    });


    React.useEffect(() => {
        axios.get(`api/front-end-option-setup?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getOptionsData = res.data.getOptions;
                setEventOptionsSetup(getOptionsData);
                // Parse the JSON string for abstractSponserLogos


            }
        });
    }, [eventid]);



    // useEffect(() => {
    //     if (!Array.isArray(editWorkShopParticpantWorkshops)) return;
    //     setSelectedWorkshopAmounts(
    //             editWorkShopParticpantWorkshops.map(({ workshop_id, workshop_code, workshop_amount, workshop_name, workshop_coupon }) => ({
    //                     id: workshop_id,
    //                     workshop_code,
    //                     workshop_amount,
    //                     workshop_name,
    //                     workshop_coupon,
    //                 }))
    //         );


    // }, [editWorkShopParticpantWorkshops]);

    useEffect(() => {
        if (!Array.isArray(editWorkShopParticpantWorkshops)) return;

        // Check if there are any workshops with payment_status === 1
        const hasUnpaidWorkshops = editWorkShopParticpantWorkshops.some(
            workshop => workshop.payment_status !== 1
        );

        // If there are unpaid workshops, update selectedWorkshopAmounts
        if (hasUnpaidWorkshops) {
            setSelectedWorkshopAmounts(
                editWorkShopParticpantWorkshops
                    .filter(workshop => workshop.payment_status !== 1)
                    .map(({ workshop_id, workshop_code, workshop_amount, workshop_name, workshop_coupon }) => ({
                        id: workshop_id,
                        workshop_code,
                        workshop_amount,
                        workshop_name,
                        workshop_coupon,
                    }))
            );
        } else {
            // If there are no unpaid workshops, clear selectedWorkshopAmounts
            setSelectedWorkshopAmounts([]);
        }


    }, [editWorkShopParticpantWorkshops]);




    const handleregistration = (e) => {
        const selectedRegistrationType = e.target.value;

        // Trigger API request with the selectedRegistrationType
        axios.get(`api/workshop-category-front-single/${selectedRegistrationType}`)
            .then((res) => {
                if (res.status === 200) {
                    const singleWorkShopData = res.data.swsd;
                    setSingleWorkShopCategory(singleWorkShopData);


                    // Update the state with the selected registration type
                    setEditWorkShopParticpant(prevState => ({
                        ...prevState,
                        particent_workshop_categoy_id: selectedRegistrationType,
                    }));
                } else {
                    swal('Error', 'Check API Something Wrong', 'error');
                }
            })
            .catch((error) => {
                console.error('API Error:', error);
                swal('Error', 'An error occurred while fetching data from the API', 'error');
            });
    };

    const [inputValues, setInputValues] = useState({}); // Use an object to store coupon codes for each workshop


    const handleCouponCodeChange = (workshopId, enteredCode) => {
        //console.log(`Updating coupon code for workshop ${workshopId} to ${enteredCode}`);
        setInputValues({ ...inputValues, [workshopId]: enteredCode });
    };


    //const couponCode = '123'; // Assuming coupon code is a string
    const [couponCodes, setCouponCodes] = useState({});

    useEffect(() => {
        axios.get(`api/workshop-manage-coupon-index-front?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.workshopCouponFront;
                setCouponCodes(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    const copyCoupon = (couponCode) => {
        navigator.clipboard
            .writeText(couponCode)
            .then(() => {
                setCopiedStates(prevState => ({ ...prevState, [couponCode]: true }));
                setTimeout(() => {
                    setCopiedStates(prevState => ({ ...prevState, [couponCode]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.log(err.message);
            });
    };

    const handleCheckboxChange = (event, workshop, workshop_amount) => {
        if (!workshop || typeof workshop !== 'object') {
            console.error('Invalid workshop object:', workshop);
            return;
        }

        const { id, workshop_url, workshop_date, workshop_start_time, workshop_code, workshop_name, workshop_coupon, payment_status } = workshop;

        const isAlreadySelected = editWorkShopParticpantWorkshops.some(
            (selectedWorkshop) => selectedWorkshop.workshop_id === id
        );

        if (event.target.checked && !isAlreadySelected) {
            const uniqueColor = getColorForFields(workshop_url, workshop_date, workshop_start_time);

            setEditWorkShopParticpantWorkshops((prevWorkshops) => [
                ...prevWorkshops,
                {
                    categoy_id: workshop.categoy_id,
                    workshop_amount,
                    payment_status,
                    workshop_code,
                    workshop_discount: workshop.workshop_discount,
                    workshop_id: workshop.id,
                    workshop_name,
                    workshop_participant_id: workshop.workshop_participant_id,
                    workshop_type: workshop.workshop_type,
                    workshop_coupon: workshop.workshop_coupon,
                    workshop_url: workshop.workshop_url,
                    workshop_date: workshop.workshop_date,
                    workshop_start_time: workshop.workshop_start_time,
                    isDisabled: false,
                },
            ]);

            setSelectedWorkshopAmounts((prevSelected) => [
                ...prevSelected,
                { id, workshop_code, workshop_amount, workshop_name, workshop_coupon, payment_status },
            ]);

            setColorMap((prevColorMap) => ({
                ...prevColorMap,
                [`${workshop_url}-${workshop_date}-${workshop_start_time}`]: uniqueColor,
            }));
        } else if (!event.target.checked && isAlreadySelected) {
            setEditWorkShopParticpantWorkshops((prevWorkshops) =>
                prevWorkshops.filter((w) => w.workshop_id !== id)
            );

            setSelectedWorkshopAmounts((prevSelected) =>
                prevSelected.filter((item) => item.id !== id)
            );

            setColorMap((prevColorMap) => {
                const newColorMap = { ...prevColorMap };
                delete newColorMap[`${workshop_url}-${workshop_date}-${workshop_start_time}`];
                return newColorMap;
            });
        }
    };

    const isCheckboxDisabled = (workshop) => {
        const { id, workshop_url, workshop_date, workshop_start_time, workshop_no_ofseats } = workshop;

        // Check if any workshop with the same URL, date, and time is already selected
        //eventOptionsSetup.workshop_setup_status === 0
        // ? selectedWorkshop.id !== id  // If status is 1, disable all workshops
        // :
        const isSameTimeWorkshopSelected = editWorkShopParticpantWorkshops.some(
            (selectedWorkshop) =>
                selectedWorkshop.workshop_url === workshop_url &&
                selectedWorkshop.workshop_date === workshop_date &&
                selectedWorkshop.workshop_start_time === workshop_start_time &&
                selectedWorkshop.workshop_id !== id // Exclude itself
        );

        const workshopDateTime = new Date(`${workshop_date}T${workshop_start_time}`).getTime();
        const currentDateTime = new Date().getTime();
        const isTimePassed = workshopDateTime < currentDateTime;

        const workshopIdToMatch = workshop.id;
        const countWorkshops = workshopTotalSeatCount?.filter(ws => ws.workshop_id === workshopIdToMatch).length || 0;
        const isSeatLimitReached = countWorkshops >= workshop_no_ofseats;

        const isDisabled = isSameTimeWorkshopSelected || isTimePassed || isSeatLimitReached;

        let seatLimitMessage = '';
        if (isSeatLimitReached) {
            seatLimitMessage = `All (${workshop_no_ofseats}) seats are full, please uncheck and proceed`;
        }

        return { isDisabled, seatLimitMessage };
    };

    const getColorForFields = (url, date, startTime) => {
        return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    };





    useEffect(() => {

        Object.keys(discountMessages).forEach(workshopId => {
            const message = discountMessages[workshopId];

        });
    }, [discountMessages]);

    useEffect(() => {

    }, [totalAmount]);

    const [usedCouponMessage, setUsedCouponMessage] = useState([]);
    useEffect(() => {
        Object.keys(usedCouponMessage).forEach(workshopId => {
            const message = usedCouponMessage[workshopId];

        });
    }, [usedCouponMessage]);

    useEffect(() => {
        const newTotalAmount = selectedWorkshopAmounts.reduce((acc, workshop) => {

            //acc function is is get one by one and sum 
            //const numbers = [1, 2, 3, 4, 5];
            // Output: 15 (1 + 2 + 3 + 4 + 5)

            let discount = 0;
            const singleWorkshopAmount = Number(workshop.workshop_amount);

            let matchingCoupon = null;

            if (Array.isArray(couponCodes)) {
                // Remove the 'const' keyword here
                matchingCoupon = couponCodes.find(couponValue => inputValues[workshop.id] === couponValue.coupon_code);
                // Use matchingCoupon as needed
            }

            const useCoupon = workshopUsedCoupeon.filter(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            const useCouponCheck = workshopUsedCoupeon.find(couponsVal => inputValues[workshop.id] === couponsVal.coupon_code);
            if (matchingCoupon) {
                if (matchingCoupon.coupon_amout_type === "percentage" && workshop.id === matchingCoupon.workshop_id &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {

                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.workshop_participant_id;

                        if (particpent_id == getPArticipentId) {

                            const currentDate = new Date(); // Current date
                            //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                            // Convert current date to the format "YYYY-MM-DD"
                            const currentYear = currentDate.getFullYear();
                            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                            const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                            const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                            const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                            if (isTimePassedExpired) {
                                const messageUsedCoupon = 'The Coupon is Expired';
                                setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                            }
                            else {
                                discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                            }

                        }
                        else if (useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                    }
                    else {

                        const currentDate = new Date(); // Current date
                        //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                        // Convert current date to the format "YYYY-MM-DD"
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                        const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = (singleWorkshopAmount * matchingCoupon.coupon_amout_value) / 100;
                        }


                    }
                }
                else if (matchingCoupon.coupon_amout_type === "fixed" && workshop.id === matchingCoupon.workshop_id &&
                    inputValues[workshop.id] === matchingCoupon.coupon_code) {
                    if (useCouponCheck) {
                        const particpent_id = id;
                        const getPArticipentId = useCouponCheck.workshop_participant_id
                        if (particpent_id == getPArticipentId) {

                            const currentDate = new Date(); // Current date
                            //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                            // Convert current date to the format "YYYY-MM-DD"
                            const currentYear = currentDate.getFullYear();
                            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                            const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                            const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                            const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                            if (isTimePassedExpired) {
                                const messageUsedCoupon = 'The Coupon is Expired';
                                setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                            }
                            else {
                                const currentDate = new Date(); // Current date
                                //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                                // Convert current date to the format "YYYY-MM-DD"
                                const currentYear = currentDate.getFullYear();
                                const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                                const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                                const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                                const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                                if (isTimePassedExpired) {
                                    const messageUsedCoupon = 'The Coupon is Expired';
                                    setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                                }
                                else {
                                    discount = matchingCoupon.coupon_amout_value;
                                }

                            }

                        }
                        else if (useCoupon && useCoupon.length > 0) {
                            const messageUsedCoupon = 'The Coupon is Already used';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));

                        }
                    }
                    else {
                        const currentDate = new Date(); // Current date
                        //const couponExpireDate = "2024-05-28"; // Coupon expiry date
                        // Convert current date to the format "YYYY-MM-DD"
                        const currentYear = currentDate.getFullYear();
                        const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
                        const currentDay = String(currentDate.getDate()).padStart(2, '0'); // Add leading zero if needed
                        const currentFormattedDate = `${currentYear}-${currentMonth}-${currentDay}`;
                        const isTimePassedExpired = matchingCoupon.coupon_expire_date <= currentFormattedDate;
                        if (isTimePassedExpired) {
                            const messageUsedCoupon = 'The Coupon is Expired';
                            setUsedCouponMessage(prevMessages => ({ ...prevMessages, [workshop.id]: messageUsedCoupon }));
                        }
                        else {
                            discount = matchingCoupon.coupon_amout_value;
                        }
                    }
                }


                if (!isNaN(singleWorkshopAmount) && discount > 0) {

                    const message = `Discount applied for workshop ${workshop.id}. Coupon Code: ${inputValues[workshop.id]}`;
                    setDiscountMessages(prevMessages => ({ ...prevMessages, [workshop.id]: message }));
                    setDisabledInputs(prevDisabled => ({ ...prevDisabled, [workshop.id]: true }));

                }
            }

            return acc + (singleWorkshopAmount - discount);
        }, 0);

        setTotalAmount(newTotalAmount);
    }, [selectedWorkshopAmounts, couponCodes, inputValues]);





    const toggleCouponInput = (workshopId) => {
        setShowCouponInputs((prevState) => ({
            ...prevState,
            [workshopId]: !prevState[workshopId],
        }));
    };

    const handleInput = (e) => {
        const value = e.target.value;
        const inputName = e.target.name;
        setEditWorkShopParticpant({ ...editWorkShopParticpant, [e.target.name]: e.target.value });


    }

    const handleCountry = (e) => {
        const selectCountry = e.target.value;
        setCountry(selectCountry);
        localStorage.setItem('selectedCountry', selectCountry);
    }

    // const handleChange = (event) => {

    //     setGender(event.target.value);
    //     localStorage.setItem(event.target.value);
    // };
    const handleChange = (event) => {
        setGender(event.target.value);

    };

    // Function to handle radio button change


    const handleNameTitle = (e) => {
        const selectNametitle = e.target.value;

        setNameTitle(selectNametitle);
        localStorage.setItem('nameTitle', selectNametitle)
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleInputChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };




    const { error_list } = addWorkShopParticpant;
    const handleSubmitBank = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked
        const paymentBank = "paymentBank";
        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.particent_saudi_council_no,
            participant_name: editWorkShopParticpant.particent_name,
            participant_email: editWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.particent_phone_number,
            participant_profession: editWorkShopParticpant.particent_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.particent_city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentBank,
            //editWorkShopParticpantWorkshops


        };



        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-update/${id}`, data, config).then(res => {
                setLoading(false);
                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                    // history.push('/workshop/particpant-form/thank-you');
                    history.push(`/workshop/thank-you/${id}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };
    const handleSubmitCash = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked
        const paymentCash = "paymentCash";
        const data = {
            partiticipant_id: id,
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.particent_saudi_council_no,
            participant_name: editWorkShopParticpant.particent_name,
            participant_email: editWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.particent_phone_number,
            participant_profession: editWorkShopParticpant.particent_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.particent_city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentCash,

        };


        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-update/${id}`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');
                    history.push(`/workshop/thank-you/${id}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };

    const handleSubmitOnline = (e) => {
        e.preventDefault();
        setLoading(true); // Set loading state to true when button is clicked

        const paymentOnline = "paymentOnline";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.particent_saudi_council_no,
            participant_name: editWorkShopParticpant.particent_name,
            participant_email: editWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.particent_phone_number,
            participant_profession: editWorkShopParticpant.particent_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.particent_city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentOnline,
        };

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/onlinepayment-workshop-particpant-update/${id}`, data, config).then(res => {
                setLoading(false); // Set loading state back to false after operation completes
                if (res.data.status === 200) {
                    const participantId = res.data.participantId;
                    swal('Success', res.data.message, 'success');
                    window.location.href = res.data.redirect.redirect_url;
                } else {
                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error });
                }
            }).catch(error => {
                setLoading(false); // Set loading state back to false in case of error
                console.error('Error:', error);
            });
        }).catch(error => {
            setLoading(false); // Set loading state back to false in case of error
            console.error('Error:', error);
        });
    };
    const handleSubmitFree = (e) => {
        e.preventDefault();

        const paymentFree = "paymentFree";
        const data = {
            eventid,
            name_title: nameTitle,
            participant_saudi_council_no: editWorkShopParticpant.particent_saudi_council_no,
            participant_name: editWorkShopParticpant.particent_name,
            participant_email: editWorkShopParticpant.particent_email,
            participant_workshop_categoy: singleWorkShopCategory.id,
            participant_contact: editWorkShopParticpant.particent_phone_number,
            participant_profession: editWorkShopParticpant.particent_profession,
            participant_gender: gender,
            participant_country: country,
            participant_city: editWorkShopParticpant.particent_city,
            selectedWorkshopAmounts,
            participant_cooupons: inputValues,
            totalAmount,
            paymentFree,

        };

        {
            data.eventid == "" ? setLoading(false) : data.name_title == "" ? setLoading(false) :
                data.participant_saudi_council_no == "" ? setLoading(false) : data.participant_name == "" ? setLoading(false) :
                    data.participant_email == "" ? setLoading(false) : data.participant_workshop_categoy == "" ? setLoading(false) :
                        data.participant_contact == "" ? setLoading(false) : data.participant_profession == "" ? setLoading(false) :
                            data.participant_gender == "" ? setLoading(false) : data.participant_country == "" ? setLoading(false) :
                                data.selectedWorkshopAmounts == "" ? setLoading(false) :
                                    data.totalAmount == "" ? setLoading(false) : data.paymentBank == "" ? setLoading(false) : setLoading(true)
        }
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/workshop-particpant-free-regisrtation-update/${id}`, data, config).then(res => {

                if (res.data.status === 200) {
                    const participantId = res.data.participantId;

                    swal('Success', res.data.message, 'success');
                    history.push(`/workshop/thank-you/${participantId}`);
                    return false;
                }
                else {

                    setAddWorkShopParticpant({ ...addWorkShopParticpant, error_list: res.data.validate_error })

                }

            });


        });
    }




    const isMobile = useMediaQuery('(max-width:600px)');

    //Check Out
    const renderSelectedWorkshopInfo = () => {


        const handleRemoveWorkshop = (workshopIdToRemove) => {
            // Filter out the workshop to remove from the state
            const updatedWorkshops = selectedWorkshopAmounts.filter(workshop => workshop.id !== workshopIdToRemove);
            // Update the state with the filtered array
            //console.log(updatedWorkshops)
            setSelectedWorkshopAmounts(updatedWorkshops);
        };
        return (
            <div>
                <TableContainer component={Paper}>
                    {/* <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>WorkShop Code</TableCell>
                                <TableCell>Used Coupons</TableCell>

                                <TableCell>WorkShop Name</TableCell>

                                <TableCell align="right"></TableCell>
                                <TableCell align="right">Workshop Amount</TableCell>
                                <TableCell align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {selectedWorkshopAmounts && selectedWorkshopAmounts.map((selectedWorkshop, index) => {
                                const partiticipant_id = id;
                                const workshopId = selectedWorkshop.id;
                                const hasCoupon = workshopUsedCoupeon.some(couponsVal => selectedWorkshop.id === couponsVal.workshop_id);
                                const foundCoupon = workshopUsedCoupeon.find(couponsVal => partiticipant_id == couponsVal.workshop_participant_id && selectedWorkshop.id === couponsVal.workshop_id);
                                const couponCode = hasCoupon ? (foundCoupon ? foundCoupon.coupon_code : '') : '';

                                return (
                                    <TableRow key={selectedWorkshop.id}>
                                        <TableCell>{selectedWorkshop.workshop_code} </TableCell>
                                        {
                                            couponCode !== "" ? (
                                                <>


                                                    <TableCell onClick={() => copyCoupon(couponCode)} style={{ cursor: 'pointer' }}><span style={{ color: 'green', fontWeight: 'bold', fontSize: '1rem' }}>click To Copy!</span> {couponCode}</TableCell>
                                                    <TableCell>{copiedStates[couponCode] && <span style={{ color: 'green', fontWeight: 'bold', fontSize: '1rem' }}>Copied!</span>}</TableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <TableCell>No Coupon</TableCell>

                                                </>
                                            )
                                        }

                                        <TableCell>{selectedWorkshop.workshop_name}</TableCell>
                                        <TableCell>
                                            {selectedWorkshop.workshop_coupon === 1 && (
                                                <Checkbox
                                                    checked={!!showCouponInputs[selectedWorkshop.id]}  // Use !! to convert to boolean
                                                    onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                />
                                            )}
                                            <div style={{
                                                marginTop: '10px', // Default margin
                                                '@media (max-width: 600px)': {
                                                    marginTop: '5px', // Adjusted margin for smaller screens
                                                }
                                            }}>

                                                {showCouponInputs[selectedWorkshop.id] && selectedWorkshop.workshop_coupon === 1 && (
                                                    <Input
                                                        type="text"
                                                        placeholder="Your Coupon Code"
                                                        value={inputValues[selectedWorkshop.id] || ''}
                                                        onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                    // disabled={disabledInputs[selectedWorkshop.id]}
                                                    />
                                                )}

                                                {discountMessages[selectedWorkshop.id] && (
                                                    <div>
                                                        <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                    </div>

                                                )}
                                                {!discountMessages[selectedWorkshop.id] && usedCouponMessage[selectedWorkshop.id] && (
                                                    <div>
                                                        <h3 style={{ color: "green" }}>{usedCouponMessage[selectedWorkshop.id]}</h3>
                                                    </div>
                                                )}
                                            </div>
                                        </TableCell>

                                        <TableCell align="right">{selectedWorkshop.workshop_amount}</TableCell>
                                        <TableCell align="right">
                                          
                                            <Button onClick={() => handleRemoveWorkshop(selectedWorkshop.id)}>Remove</Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}

                            <TableRow>
                                <TableCell colSpan={7} align="right" style={{ fontWeight: 'bold' }}> Amount: {totalAmount} </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table> */}
                    <Table>
                        <TableHead>
                            <TableRow>

                                {
                                    isMobile ? (<>

                                        <TableCell colSpan={4} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                            Workshops Details
                                        </TableCell>
                                    </>) : (
                                        <>
                                            <TableCell style={{ fontWeight: 'bold', color: '#333' }}>WorkShop Code</TableCell>

                                            {/* Used Coupons */}
                                            <TableCell style={{ fontWeight: 'bold', color: '#333' }}>Used Coupons</TableCell>

                                            {/* WorkShop Name */}
                                            <TableCell style={{ fontWeight: 'bold', color: '#333' }}>WorkShop Name</TableCell>

                                            {/* Empty Cell for alignment */}
                                            <TableCell align="right" style={{ fontWeight: 'bold', color: '#333' }}></TableCell>

                                            {/* Workshop Amount */}
                                            <TableCell align="right" style={{ fontWeight: 'bold', color: '#333' }}>Workshop Amount</TableCell>

                                            {/* Action */}
                                            <TableCell align="right" style={{ fontWeight: 'bold', color: '#333' }}>Action</TableCell>
                                        </>
                                    )
                                }
                                {/* Workshop Code */}

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {selectedWorkshopAmounts && selectedWorkshopAmounts.map((selectedWorkshop, index) => {
                                const participant_id = id;
                                const workshopId = selectedWorkshop.id;
                                const hasCoupon = workshopUsedCoupeon.some(couponsVal => selectedWorkshop.id === couponsVal.workshop_id);
                                const foundCoupon = workshopUsedCoupeon.find(couponsVal => {
                                    return String(participant_id) === String(couponsVal.workshop_participant_id) && String(selectedWorkshop.id) === String(couponsVal.workshop_id);
                                });
                                const couponCode = hasCoupon ? (foundCoupon ? foundCoupon.coupon_code : '') : '';

                                return (

                                    <>
                                        {
                                            isMobile ? (
                                                <TableCell style={{ display: 'flex', flexWrap: 'wrap', flexBasis: '100%' }} key={selectedWorkshop.id}>
                                                    <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                        <strong>No: {index + 1}</strong>
                                                        <hr />
                                                    </Box>

                                                    <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                        <strong>Workshop Code: </strong>{selectedWorkshop.workshop_code}
                                                        <hr />
                                                    </Box>

                                                    <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                        <strong>Coupon: </strong>
                                                        {couponCode ? (
                                                            <>
                                                                <span>{couponCode}</span>
                                                                <span
                                                                    onClick={() => copyCoupon(couponCode)}
                                                                    style={{ cursor: 'pointer', color: '#007bff', marginLeft: '10px' }}
                                                                >
                                                                    📋 Copy
                                                                </span>
                                                                {copiedStates[couponCode] && (
                                                                    <span style={{ marginLeft: '10px', color: 'green', fontWeight: 'bold' }}>Copied!</span>
                                                                )}
                                                            </>
                                                        ) : 'No Coupon'}
                                                        <hr />
                                                    </Box>
                                                    <Box>
                                                        <strong>Workshop Name: </strong>{selectedWorkshop.workshop_name}

                                                    </Box>
                                                    <Box>
                                                        {selectedWorkshop.workshop_coupon === 1 && (
                                                            <Checkbox
                                                                checked={!!showCouponInputs[selectedWorkshop.id]}  // Use !! to convert to boolean
                                                                onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                            />
                                                        )}
                                                        <div style={{ marginTop: '10px' }}>
                                                            {showCouponInputs[selectedWorkshop.id] && selectedWorkshop.workshop_coupon === 1 && (
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Your Coupon Code"
                                                                    value={inputValues[selectedWorkshop.id] || ''}
                                                                    onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                                />
                                                            )}

                                                            {discountMessages[selectedWorkshop.id] && (
                                                                <div>
                                                                    <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                                </div>
                                                            )}
                                                            {!discountMessages[selectedWorkshop.id] && usedCouponMessage[selectedWorkshop.id] && (
                                                                <div>
                                                                    <h3 style={{ color: "green" }}>{usedCouponMessage[selectedWorkshop.id]}</h3>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Box>


                                                    <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                        <strong>workhop Amount: </strong>{selectedWorkshop.workshop_amount}
                                                        <hr />
                                                    </Box>

                                                    <Box style={{ flexBasis: '100%', margin: '5px' }}>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => handleRemoveWorkshop(selectedWorkshop.id)}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            ) : (

                                                <TableRow key={selectedWorkshop.id}>
                                                    {/* WorkShop Code */}
                                                    <TableCell>{selectedWorkshop.workshop_code}</TableCell>

                                                    {/* Used Coupons */}
                                                    <TableCell>
                                                        {couponCode ? (
                                                            <>
                                                                <span onClick={() => copyCoupon(couponCode)} style={{ cursor: 'pointer', color: '#4caf50', fontWeight: 'bold' }}>
                                                                    <span style={{ fontSize: '1rem', color: '#007bff', marginRight: '8px' }}>📋</span>
                                                                    {couponCode}
                                                                </span>
                                                                {copiedStates[couponCode] && (
                                                                    <span style={{ color: 'green', fontWeight: 'bold', fontSize: '1rem' }}>Copied!</span>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <span>No Coupon</span>
                                                        )}
                                                    </TableCell>

                                                    {/* WorkShop Name */}
                                                    <TableCell>{selectedWorkshop.workshop_name}</TableCell>

                                                    {/* Coupon Input */}
                                                    <TableCell align="right">
                                                        {selectedWorkshop.workshop_coupon === 1 && (
                                                            <Checkbox
                                                                checked={!!showCouponInputs[selectedWorkshop.id]}  // Use !! to convert to boolean
                                                                onChange={() => toggleCouponInput(selectedWorkshop.id)}
                                                            />
                                                        )}
                                                        <div style={{ marginTop: '10px' }}>
                                                            {showCouponInputs[selectedWorkshop.id] && selectedWorkshop.workshop_coupon === 1 && (
                                                                <Input
                                                                    type="text"
                                                                    placeholder="Your Coupon Code"
                                                                    value={inputValues[selectedWorkshop.id] || ''}
                                                                    onChange={(e) => handleCouponCodeChange(selectedWorkshop.id, e.target.value)}
                                                                />
                                                            )}

                                                            {discountMessages[selectedWorkshop.id] && (
                                                                <div>
                                                                    <h3 style={{ color: "green" }}>Coupon Applied</h3>
                                                                </div>
                                                            )}
                                                            {!discountMessages[selectedWorkshop.id] && usedCouponMessage[selectedWorkshop.id] && (
                                                                <div>
                                                                    <h3 style={{ color: "green" }}>{usedCouponMessage[selectedWorkshop.id]}</h3>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </TableCell>

                                                    {/* WorkShop Amount */}
                                                    <TableCell align="right">{selectedWorkshop.workshop_amount}</TableCell>

                                                    {/* Action */}
                                                    <TableCell align="right">
                                                        {/* Remove button with onClick event */}
                                                        <Button onClick={() => handleRemoveWorkshop(selectedWorkshop.id)} variant="contained" color="secondary">
                                                            Remove
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                    </>

                                );
                            })}

                            {/* Total Amount */}
                            <TableRow>
                                <TableCell colSpan={5} align="right" style={{ fontWeight: 'bold' }}>
                                    Amount: {totalAmount}
                                </TableCell>
                            </TableRow>
                        </TableBody>


                    </Table>


                </TableContainer>
                <Box noValidate sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    {isMobile ? (
                        <>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginTop: "20px", }}>
                                {abstractHomeSetup.online_status == 1 && (
                                    <Button
                                        onClick={handleSubmitOnline}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%', // Adjusts button width to fit two in a row
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Online'}
                                    </Button>
                                )}

                                {abstractHomeSetup.bank_status == 1 && (
                                    <Button
                                        onClick={handleSubmitBank}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Bank'}
                                    </Button>
                                )}

                                {abstractHomeSetup.cash_status == 1 && (
                                    <Button
                                        onClick={handleSubmitCash}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Cash'}
                                    </Button>
                                )}

                                {abstractHomeSetup.free_status == 1 && (
                                    <Button
                                        onClick={handleSubmitFree}
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup.color_code_two
                                                ? abstractHomeSetup.color_code_two
                                                : gradientBackground,
                                            flex: '1 1 48%',
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Loading...' : 'Register'}
                                    </Button>
                                )}
                            </div>
                        </>
                    ) : (
                        <>
                            {abstractHomeSetup.online_status == 1 && (
                                <Button
                                    onClick={handleSubmitOnline}
                                    variant="contained"
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        ml: 4,
                                        mr: 2,
                                        backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                        cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                                        opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Online'}
                                </Button>
                            )}

                            {abstractHomeSetup.bank_status == 1 && (
                                <Button
                                    onClick={handleSubmitBank}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Bank'}
                                </Button>
                            )}

                            {abstractHomeSetup.cash_status == 1 && (
                                <Button
                                    onClick={handleSubmitCash}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Cash'}
                                </Button>
                            )}

                            {abstractHomeSetup.free_status == 1 && (
                                <Button
                                    onClick={handleSubmitFree}
                                    variant="contained"
                                    sx={{
                                        mt: 3, mb: 2, backgroundColor: abstractHomeSetup.color_code_two
                                            ? abstractHomeSetup.color_code_two
                                            : gradientBackground,
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? 'Loading...' : 'Register'}
                                </Button>
                            )}
                        </>
                    )}


                </Box>
                {/* <Box noValidate sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>

                    {abstractHomeSetup.online_status == 1 && (
                        <Button
                            onClick={handleSubmitOnline}
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2,
                                ml: 4,
                                mr: 2,
                                backgroundColor: abstractHomeSetup.color_code_two
                                    ? abstractHomeSetup.color_code_two
                                    : gradientBackground,
                                cursor: loading ? 'not-allowed' : 'pointer', // Disable pointer events when loading
                                opacity: loading ? 0.6 : 1, // Reduce opacity when loading
                            }}
                            disabled={loading} // Disable the button when loading
                        >
                            {loading ? 'Loading...' : 'Online'}
                        </Button>

                    )}

                    {abstractHomeSetup.bank_status == 1 && (
                        <Button
                            onClick={handleSubmitBank}
                            variant="contained"
                            sx={{
                                mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                    ? abstractHomeSetup.color_code_two
                                    : gradientBackground,
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Loading...' : 'Register'}
                        </Button>
                    )}
                 

                    {abstractHomeSetup.cash_status == 1 && (


                        <Button
                            onClick={handleSubmitCash}
                            variant="contained"
                            sx={{
                                mt: 3, mb: 2, mr: 2, backgroundColor: abstractHomeSetup.color_code_two
                                    ? abstractHomeSetup.color_code_two
                                    : gradientBackground,
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Loading...' : 'Cash'}
                        </Button>
                    )}

                    {abstractHomeSetup.free_status == 1 && (
                        <Button
                            onClick={handleSubmitFree}
                            variant="contained"
                            sx={{
                                mt: 3, mb: 2, backgroundColor: abstractHomeSetup.color_code_two
                                    ? abstractHomeSetup.color_code_two
                                    : gradientBackground,
                            }}
                            disabled={loading}
                        >
                            {loading ? 'Loading...' : 'Free'}
                        </Button>
                    )}

                </Box> */}

            </div>
        );
    };

    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <WorkshopNavbar />
            </Grid>

            <Grid container spacing={2}>
                <Box
                    sx={{
                        position: 'relative',
                        marginTop: '10px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '400px', // Adjust height for small screens
                        //backgroundImage: `url(${bannerImage})`,
                        backgroundImage: `url(${abstractHomeSetup.workshopBannerImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px', // Adjust padding for small screens
                        color: 'white',
                    }}
                >
                    {/* <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                        Workshop Management System
                    </Typography> */}
                </Box>


                <Grid container justifyContent="center" marginTop="40px">
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Typography
                            component="h1"
                            variant="h5"
                            sx={{
                                textAlign: 'center', // Center the text
                            }}>
                            WorkShop Participant Details
                        </Typography>

                        <Grid item xs={12}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid>
                        <div>
                            {activeStep === steps.length ? (
                                <div >

                                    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                            {error_list && Object.keys(error_list).map(fieldName => (
                                                <div key={fieldName}>
                                                    {/* <span style={{ color: 'red' }}>{fieldName}: </span> */}
                                                    {error_list[fieldName].map((error, index) => (
                                                        <span key={index} style={{ color: 'red' }}>{error}</span>
                                                    ))}
                                                </div>
                                            ))}


                                            <Card sx={cardStyles}  >
                                                <CardContent >
                                                    <Typography component="h1" variant="h5" sx={{
                                                        textAlign: 'center', // Center the text
                                                    }}>
                                                        Check Out

                                                    </Typography>
                                                    <Box component="form" noValidate sx={{ mt: 3 }}>

                                                        {renderSelectedWorkshopInfo()}


                                                    </Box>
                                                    <Grid container justifyContent="space-between">
                                                        <Button
                                                            //disabled={activeStep === 0}
                                                            disabled={true}
                                                            onClick={handleBack}
                                                            sx={{
                                                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                    ? abstractHomeSetup.color_code_two
                                                                    : gradientBackground,
                                                            }}>
                                                            Back
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            // onClick={handleNext}
                                                            onClick={handleBack}
                                                            sx={{
                                                                mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                    ? abstractHomeSetup.color_code_two
                                                                    : gradientBackground,
                                                            }}
                                                        >
                                                            {activeStep === steps.length - 1 ? 'Back' : 'BAck'}
                                                        </Button>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    {/* <Typography>{steps[activeStep]}</Typography> */}
                                    {/* Render your form for each step */}
                                    {activeStep === 0 && (
                                        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                                                <h4 sx={{ m: 2, color: '#000000' }} >

                                                    <Button sx={{
                                                        float: 'right',
                                                        marginTop: '2%',
                                                        backgroundColor: abstractHomeSetup.color_code_two
                                                            ? abstractHomeSetup.color_code_two
                                                            : gradientBackground,
                                                        ":hover": {
                                                            color: "white"
                                                        },
                                                    }}
                                                        color='success'
                                                        size='small'
                                                        variant='contained'
                                                        component={Link}  // Use the Link component here
                                                        to="/workshop/particpant-verification" >
                                                        Back
                                                    </Button>
                                                </h4>
                                                <Card sx={cardStyles}  >
                                                    <CardContent >

                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={4}>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Title</InputLabel>
                                                                        <Select
                                                                            value={nameTitle}
                                                                            onChange={handleNameTitle}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Action"
                                                                        >
                                                                            <MenuItem value={'Mr'}>Mr</MenuItem>
                                                                            <MenuItem value={'Mrs'}>Mrs</MenuItem>
                                                                            <MenuItem value={'Ms'}>Ms</MenuItem>
                                                                            <MenuItem value={'Dr'}>Dr</MenuItem>
                                                                            <MenuItem value={'Prof'}>Prof</MenuItem>
                                                                            <MenuItem value={'Eng'}>Eng</MenuItem>
                                                                            <MenuItem value={'Sheikh'}>Sheikh</MenuItem>
                                                                        </Select>
                                                                        <FormHelperText>{addWorkShopParticpant.error_list.name_title}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>


                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth
                                                                        label="Full Name"
                                                                        autoFocus
                                                                        name='particent_name' onChange={handleInput}
                                                                        value={editWorkShopParticpant?.particent_name || ""}
                                                                        helperText={addWorkShopParticpant?.error_list.participant_name} />
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        label="Saudi Council No"
                                                                        type="text"
                                                                        name='particent_saudi_council_no'
                                                                        onChange={handleInput}
                                                                        value={editWorkShopParticpant?.particent_saudi_council_no || ""}
                                                                        helperText={editWorkShopParticpant?.error_list?.particent_saudi_council_no || ""}
                                                                    />
                                                                    <span style={{ color: 'red', textAlign: 'center' }}>
                                                                        If you don't have, just type 0000
                                                                    </span>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Workshop Category</InputLabel>
                                                                        <Select

                                                                            value={editWorkShopParticpant?.particent_workshop_categoy_id || ""}
                                                                            // onChange={handleWorkShopCategory}
                                                                            onChange={handleregistration}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Workshop Category" >
                                                                            {
                                                                                workshopCategoryData && workshopCategoryData.map((val, index) => {
                                                                                    return (
                                                                                        <MenuItem value={val.id} key={val.id}>{val.workshop_category_title} </MenuItem>
                                                                                    )
                                                                                })
                                                                            }



                                                                        </Select>

                                                                        <FormHelperText>{addWorkShopParticpant.error_list.participant_workshop_categoy}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        id="email"
                                                                        label="Email Address"
                                                                        autoComplete="particent_email"
                                                                        name='particent_email'
                                                                        onChange={handleInput}
                                                                        value={editWorkShopParticpant?.particent_email || ""}
                                                                        helperText={editWorkShopParticpant?.error_list?.particent_email || ""}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        required
                                                                        fullWidth
                                                                        label="Contact Number"
                                                                        type="text"
                                                                        name='particent_phone_number'
                                                                        onChange={handleInput}
                                                                        value={editWorkShopParticpant?.particent_phone_number || ""}
                                                                        helperText={editWorkShopParticpant?.error_list?.particent_phone_number || ""}
                                                                    />
                                                                    {/* <span style={{ color: 'red', textAlign: 'center' }}>
                                                                If you don't have, just type 0000
                                                            </span> */}
                                                                </Grid>



                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth

                                                                        label="Profession"
                                                                        autoFocus
                                                                        name='particent_profession'
                                                                        onChange={handleInput} value={editWorkShopParticpant?.particent_profession || ""}
                                                                        helperText={editWorkShopParticpant?.error_list?.particent_profession} />
                                                                </Grid>
                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl>
                                                                        <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                                                                        <RadioGroup
                                                                            row
                                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                                            name="row-radio-buttons-group"
                                                                            value={gender.toString()}  // Convert the numeric value to a string
                                                                            onChange={handleChange}
                                                                        >
                                                                            <FormControlLabel value="0" control={<Radio />} label="Male" />
                                                                            <FormControlLabel value="1" control={<Radio />} label="Female" />
                                                                        </RadioGroup>
                                                                        <FormHelperText>{addWorkShopParticpant.error_list.participant_gender}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>


                                                                <Grid item xs={12} lg={6} sm={12}>
                                                                    <FormControl fullWidth>
                                                                        <InputLabel id="demo-simple-select-label">Country</InputLabel>
                                                                        <Select
                                                                            value={country || ""}
                                                                            onChange={handleCountry}
                                                                            labelId="demo-simple-select-label"
                                                                            id="demo-simple-select"
                                                                            label="Action" >
                                                                            <MenuItem value={'Saudi Arabia'}>Saudi Arabia</MenuItem>
                                                                            <MenuItem value={'UAE'}>UAE</MenuItem>
                                                                            <MenuItem value={'Qatar'}> Qatar</MenuItem>
                                                                            <MenuItem value={'Oman'}>Oman </MenuItem>
                                                                            <MenuItem value={'Jordan'}>Jordan</MenuItem>
                                                                            <MenuItem value={'Trurky'}>Trurky </MenuItem>

                                                                        </Select>
                                                                        <FormHelperText></FormHelperText>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={12} lg={6} sm={12} >
                                                                    <TextField
                                                                        autoComplete="given-name"
                                                                        required
                                                                        fullWidth
                                                                        label="City"
                                                                        autoFocus
                                                                        name='particent_city' onChange={handleInput} value={editWorkShopParticpant?.particent_city || ""} />
                                                                </Grid>
                                                            </Grid>


                                                            <Grid container justifyContent="space-between">
                                                                <Button
                                                                    disabled={activeStep === 0}
                                                                    onClick={handleBack}
                                                                    sx={{ mt: 5 }}>
                                                                    Back
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                                </Button>
                                                            </Grid>

                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>

                                    )}
                                    {activeStep === 1 && (
                                        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
                                            <Box sx={{ color: '#000000', mt: '5%' }}>
                                                <Card sx={cardStyles}>
                                                    <CardContent>
                                                        <Typography component="h1" variant="h5" sx={{ textAlign: 'center' }}>
                                                            WorkShop Registration
                                                        </Typography>
                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={4}>
                                                                <Grid item xs={12} sm={6} md={4} lg={6}>
                                                                    <Box display="flex" alignItems="center">
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    color="success"
                                                                                    checked={singleWorkShopCategory.workshop_category_title !== null}
                                                                                />
                                                                            }
                                                                            label="WorkShop Registration"
                                                                            name="permissions"
                                                                        />
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container justifyContent="space-between">
                                                                <Button
                                                                    disabled={activeStep === 0}
                                                                    onClick={handleBack}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    Back
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                                </Button>
                                                            </Grid>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>
                                    )}
                                    {activeStep === 2 && (
                                        <div style={{ margin: '1%', width: '100%', }}>
                                            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>

                                                <Card sx={{ width: '100%', float: 'center' }} >
                                                    <CardContent >
                                                        <Typography component="h1" variant="h5" sx={{
                                                            textAlign: 'center', // Center the text
                                                        }}>
                                                            Registration Fees
                                                        </Typography>
                                                        <br></br>
                                                        <Typography
                                                            component="h6"
                                                            variant="h5"
                                                            sx={{
                                                                textAlign: 'center', // Center the text
                                                                color: 'red', // Set the text color to red
                                                            }} >
                                                            {addWorkShopParticpant.error_list.selectedWorkshopAmounts}
                                                        </Typography>


                                                        <Box component="form" noValidate sx={{ mt: 3 }}>
                                                            <Grid container spacing={4}>

                                                                <Grid item xs={6} >

                                                                </Grid>

                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <FormControlLabel
                                                                    control={<Checkbox color="success" checked={singleWorkShopCategory.workshop_category_title !== null} />}
                                                                    label={
                                                                        <span
                                                                            sx={{
                                                                                margin: '55px',
                                                                                display: 'inline-block',
                                                                            }}
                                                                        >
                                                                            {singleWorkShopCategory.workshop_category_title}
                                                                        </span>
                                                                    }
                                                                    color="success"
                                                                    name="permissions"
                                                                />

                                                                <TableContainer component={Paper}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell>ID</TableCell>
                                                                                <TableCell>WorkShop Name</TableCell>
                                                                                <TableCell>WorkShop Day</TableCell>
                                                                                <TableCell>WokShopData</TableCell>
                                                                                <TableCell>WorkShop Start Time</TableCell>
                                                                                <TableCell>WorkShop End Time</TableCell>
                                                                                <TableCell>WorkShop Code</TableCell>
                                                                                <TableCell>Price</TableCell>
                                                                                <TableCell>Select</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>

                                                                            {singleWorkShopCategory.work_shops &&
                                                                                singleWorkShopCategory.work_shops.map((row, i) => {
                                                                                    // const { isDisabled, color } = isCheckboxDisabled(row);
                                                                                    const { isDisabled, color, seatLimitMessage } = isCheckboxDisabled(row);

                                                                                    // Determine if the current row has a color applied


                                                                                    const paidWorkshops = updateWorkShopParticpantWorkshops.some((alreadySelected) =>
                                                                                        alreadySelected.workshop_id = row.id
                                                                                        &&
                                                                                        alreadySelected.workshop_url === row.workshop_url
                                                                                        &&
                                                                                        alreadySelected.payment_status === 1
                                                                                        &&
                                                                                        alreadySelected.workshop_date === row.workshop_date &&

                                                                                        //alreadySelected.payment_status ===  1 &&
                                                                                        alreadySelected.workshop_start_time === row.workshop_start_time)


                                                                                    const notPaidWorkshops = updateWorkShopParticpantWorkshops.filter(workshop =>
                                                                                        workshop.workshop_id === false && workshop.payment_status === 0

                                                                                    );


                                                                                    const backgroundColor = paidWorkshops ? '#4caf50' : color || 'white'; // Default to white if no color is set

                                                                                    // Determine the text color based on the background color
                                                                                    const textColor = backgroundColor === 'white' ? 'black' : 'white';
                                                                                    return (
                                                                                        <TableRow
                                                                                            key={row.id}
                                                                                            // style={{
                                                                                            //     backgroundColor: isCheckboxDisabled(row).color,
                                                                                            //     ...(paidWorkshops && { backgroundColor: '#4caf50', color: 'white !important' })
                                                                                            // }}
                                                                                            style={{
                                                                                                backgroundColor,
                                                                                                color: textColor,
                                                                                            }}
                                                                                        >
                                                                                            <TableCell style={{ color: textColor }}>{i + 1}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_name}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_url}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_date}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_start_time}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_end_time}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_code}</TableCell>
                                                                                            <TableCell style={{ color: textColor }}>{row.workshop_amount}</TableCell>
                                                                                            <TableCell>
                                                                                                {
                                                                                                    paidWorkshops ? (
                                                                                                        <Checkbox
                                                                                                            {...label}
                                                                                                            disabled

                                                                                                            sx={{
                                                                                                                color: pink[800],
                                                                                                                '&.Mui-checked': {
                                                                                                                    color: pink[600],
                                                                                                                },
                                                                                                            }}

                                                                                                        />
                                                                                                    ) :

                                                                                                        (
                                                                                                            notPaidWorkshops.some(workshop => workshop.workshop_code === row.workshop_code) ? (
                                                                                                                <>
                                                                                                                    {/* <span>selected already</span> */}
                                                                                                                    <Checkbox
                                                                                                                        checked={editWorkShopParticpantWorkshops.some((selectedWorkshop) => selectedWorkshop.workshop_id === row.id)}
                                                                                                                        onChange={(e) => handleCheckboxChange(e, row, row.workshop_amount)}
                                                                                                                        // Apply the same disabling logic
                                                                                                                        disabled={
                                                                                                                            editWorkShopParticpantWorkshops.some(
                                                                                                                                (selectedWorkshop) =>
                                                                                                                                    selectedWorkshop.workshop_id !== row.id && // exclude itself
                                                                                                                                    selectedWorkshop.workshop_url === row.workshop_url &&
                                                                                                                                    selectedWorkshop.workshop_date === row.workshop_date &&
                                                                                                                                    selectedWorkshop.workshop_start_time === row.workshop_start_time
                                                                                                                            )
                                                                                                                        }
                                                                                                                    />
                                                                                                                </>

                                                                                                            )
                                                                                                                : (


                                                                                                                    <>
                                                                                                                        {/* <span>not selete already</span> */}
                                                                                                                        <Checkbox
                                                                                                                            checked={editWorkShopParticpantWorkshops.some((selectedWorkshop) => selectedWorkshop.workshop_id === row.id)}
                                                                                                                            onChange={(e) => handleCheckboxChange(e, row, row.workshop_amount)}
                                                                                                                            // UPDATED: Disable other checkboxes if any workshop is selected
                                                                                                                            disabled={
                                                                                                                                editWorkShopParticpantWorkshops.some(
                                                                                                                                    (selectedWorkshop) =>
                                                                                                                                        selectedWorkshop.workshop_id !== row.id && // not itself
                                                                                                                                        selectedWorkshop.workshop_url === row.workshop_url &&
                                                                                                                                        selectedWorkshop.workshop_date === row.workshop_date &&
                                                                                                                                        selectedWorkshop.workshop_start_time === row.workshop_start_time
                                                                                                                                )
                                                                                                                            } />
                                                                                                                    </>
                                                                                                                )


                                                                                                        )


                                                                                                }
                                                                                                <br></br>
                                                                                                <br></br>
                                                                                                {isCheckboxDisabled(row).seatLimitMessage && (
                                                                                                    <span style={{ color: 'red' }}>
                                                                                                        {isCheckboxDisabled(row).seatLimitMessage}
                                                                                                    </span>
                                                                                                )}

                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    );
                                                                                })}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                            <Grid container justifyContent="space-between">
                                                                <Button

                                                                    disabled={activeStep === 0}
                                                                    onClick={handleBack}
                                                                    sx={{ mt: 5 }}>
                                                                    Back
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={handleNext}
                                                                    sx={{
                                                                        mt: 5, backgroundColor: abstractHomeSetup.color_code_two
                                                                            ? abstractHomeSetup.color_code_two
                                                                            : gradientBackground,
                                                                    }}
                                                                >
                                                                    {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                                                </Button>
                                                            </Grid>

                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        </div>
                                    )}



                                </div>
                            )}
                        </div>
                    </Grid>
                </Grid>






            </Grid>

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    )
}


export default UpdateWorkShops;
